"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wranggleBackendApiBaseUrl = exports.wranggleBackendApiBaseUrlOverride = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
function wranggleBackendApiBaseUrlOverride() {
    let res;
    res = res || _inObj(global[constants_iso_1.GlobalContextName], constants_iso_1.GlobalAttribName.BackendApiBaseUrl);
    res = res || (typeof process !== 'undefined') && _inObj(process['env'], constants_iso_1.EnvVarName.WranggleApiBaseUrl);
    res = res || _inObj(global['sessionStorage'], constants_iso_1.GlobalAttribName.BackendApiBaseUrl);
    res = res || _inObj(global['localStorage'], constants_iso_1.GlobalAttribName.BackendApiBaseUrl);
    return res;
}
exports.wranggleBackendApiBaseUrlOverride = wranggleBackendApiBaseUrlOverride;
function wranggleBackendApiBaseUrl() {
    return wranggleBackendApiBaseUrlOverride() || constants_iso_1.DefaultWranggleBackendApiBaseUrl;
}
exports.wranggleBackendApiBaseUrl = wranggleBackendApiBaseUrl;
function _inObj(obj, attrib) {
    if (obj && typeof obj === 'object') {
        return obj[attrib];
    }
}
//# sourceMappingURL=wranggle-base-url.js.map